import { Fragment } from "react";
import "./Web3dappDevelopment.css";
import { web3Development } from "../../staticdata";
import web3dappbanner from "../../assets/images/services/web3/web3dappbanner.png";

const Web3dappDevelopment = () => {
  return (
    <Fragment>
      <section className="web3dappdev-style">
        <div className="web3dappdev-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="web3dappdev-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Web3 Dapp Development Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Collaborate with an experienced Web3 development company to
                  build innovative and highly interactive digital solutions. Our
                  skilled team serves diverse industries, from education to
                  fintech, delivering tailored services to meet your unique
                  needs. We focus on creating scalable, future-ready platforms
                  that transform businesses.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={web3dappbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="web3dappdev-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Web3 Dapp Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {web3Development.map((services, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={services.id}
                  data-aos="zoom-in"
                >
                  <div className="web3dappdev-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Web3dappDevelopment;
